module.exports = __webpack_public_path__ + "static/media/footer-linkedin.d52422fb.svg";